/* Front page: the opener's changing word, live product rows (with "Shop your way"), and bundles.
   Builds on the helpers universo.js puts on window.UB. */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get: (k, d) => { try { const v = localStorage.getItem(k); return v === null ? d : v; } catch (e) { return d; } },
    set: (k, v) => { try { v ? localStorage.setItem(k, v) : localStorage.removeItem(k); } catch (e) {} }
  };

  /* the opener's word: one sentence for screen readers, a turning word for everyone else */
  function words() {
    const box = $('.op [data-words]'); if (!box || REDUCED) return;
    const w = box.children; if (w.length < 2) return;
    let i = 0;
    setInterval(() => {
      if (document.hidden) return;
      const o = w[i]; i = (i + 1) % w.length;
      o.classList.remove('on'); o.classList.add('out');
      w[i].classList.remove('out'); w[i].classList.add('on');
      setTimeout(() => o.classList.remove('out'), 650);
    }, 2800);
  }

  /* live rows: load the chosen tab's cards when the row comes near the screen */
  function rows() {
    $$('[data-ftabs]').forEach(sec => {
      const track = $('[data-ft-track]', sec), all = $('[data-ft-all]', sec), tabs = $$('.ft-tab', sec);
      const way = sec.dataset.mode === 'way';
      const saved = $('[data-ft-saved]', sec);
      let loaded = false, token = 0;
      const load = async url => {
        const my = ++token;
        track.setAttribute('aria-busy', 'true');
        if (all) all.href = url;
        try {
          const h = await UB.fetchSection(url, 'fetch-row');
          if (my !== token) return;
          const cards = $$('[data-card]', UB.html(h));
          track.replaceChildren(...cards);
          if (!cards.length) track.innerHTML = '<p class="ft-empty">Nothing on this shelf right now. Try another.</p>';
          track.scrollLeft = 0;
          UB.fitAll(track); UB.markSaved(track); UB.syncControls(); UB.wireRows(sec);
        } catch (e) { if (my === token) track.innerHTML = '<p class="ft-empty">This shelf did not load. Check your connection and try again.</p>'; }
        finally { if (my === token) track.removeAttribute('aria-busy'); }
      };
      const pick = (tab, remember) => {
        tabs.forEach(t => t.setAttribute('aria-selected', String(t === tab)));
        const panel = $('[role=tabpanel]', sec); if (panel) panel.setAttribute('aria-labelledby', tab.id);
        if (way && remember) { store.set('ub-way', tab.dataset.key); document.documentElement.dataset.way = tab.dataset.key; }
        if (saved) saved.hidden = !(way && store.get('ub-way', ''));
        load(tab.dataset.url);
      };
      let start = tabs[0];
      if (way) { const k = store.get('ub-way', ''); start = tabs.find(t => t.dataset.key === k) || tabs[0]; if (saved) saved.hidden = !k; }
      if (start && start !== tabs[0]) tabs.forEach(t => t.setAttribute('aria-selected', String(t === start)));
      tabs.forEach(t => t.addEventListener('click', () => pick(t, true)));
      // arrow keys move between tabs
      sec.addEventListener('keydown', e => {
        const i = tabs.indexOf(document.activeElement); if (i < 0 || !/^Arrow(Left|Right)$/.test(e.key)) return;
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; n.focus(); pick(n, true); e.preventDefault();
      });
      $('[data-ft-forget]', sec)?.addEventListener('click', () => { store.set('ub-way', ''); delete document.documentElement.dataset.way; if (saved) saved.hidden = true; });
      const first = () => { if (loaded) return; loaded = true; load(start ? start.dataset.url : track.dataset.url); };
      if (!('IntersectionObserver' in window)) return first();
      const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); first(); } }, { rootMargin: '600px 0px' });
      io.observe(sec);
    });
  }

  /* bundles: every case of the bundle in one go */
  function bundles() {
    document.addEventListener('click', async e => {
      const b = e.target.closest('[data-bundle]'); if (!b || b.getAttribute('aria-busy')) return;
      // "id" or "id:qty", separated by commas
      const items = b.dataset.bundle.split(',').filter(Boolean).map(x => { const [id, q] = x.split(':'); return { id: +id, quantity: Math.max(1, +q || 1) }; });
      if (items.length) await UB.addMany(items, b);
    });
  }

  const init = () => [words, rows, bundles].forEach(f => { try { f(); } catch (e) {} });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
